module.exports = __webpack_public_path__ + "static/media/test4_3.3fa72081.png";